/* Amar y YA! — Holiday hero: glass ornament refracting the headline (three r160) */
import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.min.js';

const FRAG = `
precision highp float;
varying vec2 vUv;
uniform float uTime; uniform vec2 uRes; uniform sampler2D uText; uniform float uScroll; uniform vec2 uMouse;
float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
float n2(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);
  return mix(mix(h(i),h(i+vec2(1,0)),u.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),u.x),u.y);}
float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n2(p);p=p*2.02+vec2(1.7,9.2);a*=.5;}return v;}
void main(){
  vec2 uv=vUv; vec2 p=(uv-.5)*vec2(uRes.x/uRes.y,1.);
  float t=uTime*.06;
  vec2 q=vec2(fbm(p*1.3+vec2(t,-t)),fbm(p*1.3+vec2(-t*.8,t*.6)+3.1));
  float n=fbm(p*1.7+q*1.6+uMouse*.15);
  float silk=sin((p.x*1.1+p.y*1.9+n*3.4)*3.2+uTime*.2)*.5+.5;
  vec3 c0=vec3(.022,.004,.009), c1=vec3(.20,.018,.045), c2=vec3(.72,.05,.11), g=vec3(.91,.76,.50);
  vec3 col=mix(c0,c1,smoothstep(.25,.85,n));
  col=mix(col,c2,smoothstep(.62,1.,n)*.55);
  col+=g*pow(silk,9.)*.22*smoothstep(.35,.9,n);
  col*=smoothstep(1.35,.15,length(p*vec2(.75,1.05)));
  vec4 tx=texture2D(uText,uv+vec2(0.,-uScroll*.18));
  col=mix(col,vec3(.957,.925,.878),tx.a);
  gl_FragColor=vec4(col,1.);
}`;
const VERT = `varying vec2 vUv; void main(){vUv=uv; gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);}`;

function init(root) {
  if (root.dataset.hxInit) return; root.dataset.hxInit = '1';
  const canvas = root.querySelector('.hx-hero__gl');
  const titleEl = root.querySelector('.hx-hero__title');
  const words = (root.dataset.title || 'Navidad').toUpperCase();
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let renderer, started = false;
  try { renderer = new THREE.WebGLRenderer({ canvas, antialias: true, powerPreference: 'high-performance' }); }
  catch (e) { return; }
  const mobileQ = () => root.clientWidth < 750;
  renderer.setPixelRatio(Math.min(devicePixelRatio || 1, mobileQ() ? 1.5 : 1.75));
  renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(35, 1, .1, 100);
  camera.position.set(0, 0, 11); scene.add(camera);

  const pm = new THREE.PMREMGenerator(renderer);
  const env = new THREE.Scene();
  env.add(new THREE.Mesh(new THREE.BoxGeometry(30, 30, 30), new THREE.MeshBasicMaterial({ color: 0x1a0408, side: THREE.BackSide })));
  const panel = (c, k, x, y, z, w, hh) => { const m = new THREE.Mesh(new THREE.PlaneGeometry(w, hh), new THREE.MeshBasicMaterial({ color: new THREE.Color(c).multiplyScalar(k), side: THREE.DoubleSide })); m.position.set(x, y, z); m.lookAt(0, 0, 0); env.add(m); };
  panel(0xfff1d6, 9, 0, 12, 4, 14, 5); panel(0xff2238, 5, -13, 1, 2, 5, 14); panel(0xf2c98a, 6, 13, -2, 3, 5, 12); panel(0xffffff, 3, 3, 4, 14, 8, 4); panel(0x7a0b16, 3, 0, -12, -6, 20, 6);
  scene.environment = pm.fromScene(env, .035).texture;
  const key = new THREE.DirectionalLight(0xfff0dc, 1.4); key.position.set(4, 6, 8); scene.add(key);

  const tc = document.createElement('canvas'); const tctx = tc.getContext('2d');
  const tex = new THREE.CanvasTexture(tc); tex.minFilter = THREE.LinearFilter; tex.generateMipmaps = false;
  const bgU = { uTime: { value: 0 }, uRes: { value: new THREE.Vector2(1, 1) }, uText: { value: tex }, uScroll: { value: 0 }, uMouse: { value: new THREE.Vector2() } };
  const bg = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.ShaderMaterial({ vertexShader: VERT, fragmentShader: FRAG, uniforms: bgU, depthWrite: false, toneMapped: false }));
  bg.position.z = -20; bg.renderOrder = -1; camera.add(bg);

  function drawText() {
    const w = root.clientWidth, hh = root.clientHeight, s = Math.min(2, renderer.getPixelRatio());
    const nw = Math.round(w * s), nh = Math.round(hh * s);
    if (nw !== tc.width || nh !== tc.height) { tc.width = nw; tc.height = nh; tex.dispose(); }
    tctx.clearRect(0, 0, tc.width, tc.height);
    const ff = getComputedStyle(titleEl).fontFamily;
    const mob = mobileQ();
    const lines = mob ? [words.slice(0, Math.ceil(words.length / 2)), words.slice(Math.ceil(words.length / 2))] : [words];
    const track = -0.05;
    const lineW = (l, sz) => { let w = 0; for (let i = 0; i < l.length; i++) w += adv(l, i); return w + track * sz * (l.length - 1); };
    const adv = (l, i) => i < l.length - 1 ? tctx.measureText(l[i] + l[i + 1]).width - tctx.measureText(l[i + 1]).width : tctx.measureText(l[i]).width;
    let size = 400; tctx.font = `800 ${size}px ${ff}`;
    const target = tc.width * (mob ? .92 : .94);
    size = size * target / Math.max(...lines.map(l => lineW(l, 400)));
    tctx.font = `800 ${size}px ${ff}`;
    tctx.fillStyle = '#fff'; tctx.textAlign = 'left'; tctx.textBaseline = 'middle';
    const lh = size * .8, cy = tc.height * (mob ? .44 : .47);
    lines.forEach((l, li) => {
      let x = (tc.width - lineW(l, size)) / 2; const y = cy + (li - (lines.length - 1) / 2) * lh;
      for (let i = 0; i < l.length; i++) { tctx.fillText(l[i], x, y); x += adv(l, i) + track * size; }
    });
    tex.needsUpdate = true;
    if (reduce && started) frame();
  }

  const glass = new THREE.MeshPhysicalMaterial({ color: 0xffffff, metalness: 0, roughness: .02, transmission: 1, thickness: .7, ior: 1.32,
    iridescence: 1, iridescenceIOR: 1.3, iridescenceThicknessRange: [120, 640], clearcoat: 1, clearcoatRoughness: .04, envMapIntensity: 1.7,
    specularIntensity: 1 });
  const redC = new THREE.MeshPhysicalMaterial({ color: 0xc8102a, metalness: .85, roughness: .14, clearcoat: 1, clearcoatRoughness: .08, envMapIntensity: 1.4 });
  const gold = new THREE.MeshPhysicalMaterial({ color: 0xe8c88a, metalness: 1, roughness: .16, envMapIntensity: 1.5 });
  const pearl = new THREE.MeshPhysicalMaterial({ color: 0xf4ece0, metalness: .1, roughness: .25, sheen: 1, sheenColor: new THREE.Color(0xffd6c0), clearcoat: 1, envMapIntensity: 1.2 });

  const sph = new THREE.SphereGeometry(1, 96, 96);
  function ornament(mat, r) {
    const g = new THREE.Group();
    const b = new THREE.Mesh(sph, mat); b.scale.setScalar(r); g.add(b);
    const cap = new THREE.Mesh(new THREE.CylinderGeometry(r * .2, r * .24, r * .26, 48), gold); cap.position.y = r * 1.04; g.add(cap);
    const ring = new THREE.Mesh(new THREE.TorusGeometry(r * .11, r * .028, 16, 48), gold); ring.position.y = r * 1.24; g.add(ring);
    return g;
  }
  function star(sc) {
    const s = new THREE.Shape(); for (let i = 0; i < 10; i++) { const a = i / 10 * Math.PI * 2 - Math.PI / 2, rr = i % 2 ? .42 : 1; i ? s.lineTo(Math.cos(a) * rr, Math.sin(a) * rr) : s.moveTo(Math.cos(a) * rr, Math.sin(a) * rr); }
    const geo = new THREE.ExtrudeGeometry(s, { depth: .3, bevelEnabled: true, bevelThickness: .14, bevelSize: .1, bevelSegments: 6, curveSegments: 4 }); geo.center();
    const m = new THREE.Mesh(geo, gold); m.scale.setScalar(sc); return m;
  }

  const world = new THREE.Group(); scene.add(world);
  const items = [];
  const put = (o, x, y, z, spin) => { o.userData = { x, y, z, spin, ph: Math.random() * 6.28 }; o.position.set(x, y, z); world.add(o); items.push(o); return o; };
  const hero = ornament(glass, 1.45);
  const inner = star(.42); hero.add(inner);
  put(hero, .15, .05, 0, .18);
  put(ornament(redC, .62), -3.3, 1.55, -1.2, .5);
  put(ornament(gold, .42), 3.7, -.9, .6, .6);
  put(star(.5), 3.0, 1.9, -1.8, .7);
  put(ornament(pearl, .34), -4.3, -.7, -1.2, .4);
  for (let i = 0; i < 5; i++) { const m = new THREE.Mesh(sph, glass); const r = .07 + Math.random() * .1; m.scale.setScalar(r); put(m, (Math.random() - .5) * 8, (Math.random() - .5) * 4.6, (Math.random() - .5) * 3, .2); }

  function layout() {
    const w = root.clientWidth, hh = root.clientHeight, mob = mobileQ();
    renderer.setSize(w, hh, false); camera.aspect = w / hh; camera.updateProjectionMatrix();
    const vh = 2 * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2)) * 20; bg.scale.set(vh * camera.aspect, vh, 1);
    bgU.uRes.value.set(w, hh);
    const k = mob ? .5 : 1;
    world.scale.setScalar(mob ? .78 : 1);
    items.forEach(o => { o.position.x = o.userData.x * k; });
    drawText();
  }
  layout();
  (window.ResizeObserver ? new ResizeObserver(layout).observe(root) : addEventListener('resize', layout));
  if (document.fonts) { document.fonts.ready.then(drawText); document.fonts.addEventListener && document.fonts.addEventListener('loadingdone', drawText); }
  setTimeout(drawText, 1200);

  let tx = 0, ty = 0, mx = 0, my = 0, sp = 0, vis = true, run = false;
  addEventListener('pointermove', e => { tx = e.clientX / innerWidth - .5; ty = e.clientY / innerHeight - .5; }, { passive: true });
  if (window.IntersectionObserver) new IntersectionObserver(e => { vis = e[0].isIntersecting; if (vis) loop(); }).observe(root);
  const clock = new THREE.Clock(); let intro = 0;
  function frame() {
    const dt = Math.min(clock.getDelta(), .05), t = clock.elapsedTime;
    intro = Math.min(1, intro + dt / 1.8); const e = 1 - Math.pow(1 - intro, 4);
    const r = root.getBoundingClientRect(); sp = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
    mx += (tx - mx) * .045; my += (ty - my) * .045;
    world.rotation.y = mx * .35; world.rotation.x = my * .22;
    world.position.y = (1 - e) * -2.5 + sp * 2.6;
    hero.scale.setScalar((.55 + e * .45) * (1 + sp * .25));
    hero.rotation.y += dt * .22; hero.rotation.z = Math.sin(t * .5) * .06;
    inner.rotation.y -= dt * .9; inner.rotation.x = Math.sin(t * .7) * .3;
    for (const o of items) { if (o === hero) continue; const u = o.userData;
      o.position.y = u.y + Math.sin(t * .7 + u.ph) * .22 + sp * (u.z + 1.5) * .8; o.rotation.y += dt * u.spin; o.rotation.x += dt * u.spin * .3; }
    camera.position.x = mx * .6; camera.position.y = -my * .4; camera.lookAt(0, 0, 0);
    bgU.uTime.value = t; bgU.uScroll.value = sp; bgU.uMouse.value.set(mx, my);
    renderer.render(scene, camera);
  }
  function loop() { if (run) return; run = true; (function tick() { if (!vis || document.hidden) { run = false; return; } frame(); requestAnimationFrame(tick); })(); }
  document.addEventListener('visibilitychange', () => { if (!document.hidden) loop(); });
  started = true;
  if (reduce) { intro = 1; frame(); } else loop();
  requestAnimationFrame(() => root.classList.add('is-gl'));
}
const boot = () => document.querySelectorAll('[data-hx-hero]').forEach(init);
boot(); document.addEventListener('shopify:section:load', boot);
